// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"a75d94bc","372":"938dab17","466":"07d30bb9","612":"b9b5451f","856":"577b7a42"}[chunkId] + ".chunk.js";
};